import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import { bindAll } from 'underscore';

Snappy.Component.SocialShare = class SocialShare extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-social-share';
    }

    constructor(element) {
        super(element);

    }

    setVars() {
        this.srcBase = 's7.addthis.com/js/300/addthis_widget.js';
        this.defaultHash = '#pubid=ra-582c3c26b5e577a5';
        this.scriptEl = $('script[src*="s7.addthis.com/js/300/addthis_widget.js"]');
        this.hash = this.$element.data('hash') || this.defaultHash;
        this.$total = this.$element.find('.total-count__number');
        this.currentSection =  this.$element.data('currentSection');

    }

    addEventListeners() {
        window.addthis.addEventListener('addthis.ready', this.onAddThisReady.bind(this));
        window.addthis.addEventListener('addthis.menu.share', this.shareEventHandler.bind(this));
    }

    render() {
        bindAll(this, 'detectAddThisElements');
        this.setVars();


        if (!this.scriptEl.length) {
            this.loadScript().then(()=>{
                this.addEventListeners();
                this.fetchTotalShares();
            }).catch(() =>{
                console.log('cannot load script');
            });
        } else {
            this.addEventListeners();
            this.fetchTotalShares();
        }
    }

    fetchTotalShares() {
        window.addthis.sharecounters.getShareCounts({ service: 'facebook', countUrl: window.location.href }, this.onShareServiceResponse.bind(this));
    }

    onAddThisReady() {
        this.detectAddThisElements();
    }

    detectAddThisElements() {
        let $elements = this.$element.find('.at-share-btn');

        if ($elements.length) {
            $elements.attr('tabindex', 0);
        } else {
            window.setTimeout(this.detectAddThisElements, 200);
        }
    }

    onShareServiceResponse(data) {
        let content;
        if (data && data[0].count) {
            content = data[0].count;
        } else {
            content = 0;
        }

        this.$total.text(content);
    }

    shareEventHandler(e) {
        const data = e.data;
        this.$window.trigger('gtm:send', [ this.currentSection, data.service, data.title]);
    }

    loadScript() {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                const  script = document.createElement('script');
                script.src=`//${this.srcBase}${this.hash}`;
                script.async = true;
                script.onload = () => {
                    setTimeout(()=> {
                        resolve();
                    },500);
                };

                script.onerror = () => {
                    reject();
                };

                document.body.appendChild(script);

            }, 2000);
        });
    }
};



// WEBPACK FOOTER //
// ./components/socialShare/scripts/socialShare.js